<template>
    <v-card outlined>
        <v-card-title>
            <div class="t-heading-medium">Módulo: {{ index + 1 }}</div>
            <v-spacer />
            <v-btn icon color="error" @click="$emit('remove')">
                <v-icon>mdi-trash-can</v-icon>
            </v-btn>
        </v-card-title>
        <v-card-text>
            <v-row>
                <v-col cols="12" sm="6">
                    <model-select
                        v-model="selectedModule"
                        name="module_id"
                        :model="moduleModel"
                        :item-text="'name'"
                        :item-value="'external_id'"
                        :label="$t('planPackageModules.form.labels.module')"
                        @change="selectModule"
                    />
                </v-col>
                <v-col cols="12" sm="6">
                    <v-text-field
                        v-model="localOrder"
                        :label="$t('planPackageModules.form.labels.order')"
                        type="number"
                    />
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12" sm="4">
                    <v-currency-field
                        v-bind="$t('money-config')"
                        v-model="localPrice"
                        :label="$t('planPackageModules.form.labels.price')"
                    />
                </v-col>
                <v-col cols="12" sm="4">
                    <v-radio-group
                        v-model="localAddOn"
                        row
                        @change="addOnChange"
                    >
                        <template #label>
                            <div>
                                <strong>{{
                                    $t('planPackageModules.form.labels.add_on')
                                }}</strong>
                            </div>
                        </template>
                        <v-radio :label="$t('form.status.yes')" :value="true" />
                        <v-radio :label="$t('form.status.no')" :value="false" />
                    </v-radio-group>
                </v-col>
                <v-col cols="12" sm="4">
                    <v-radio-group v-model="localPriceType" row>
                        <template #label>
                            <div>
                                <strong>{{
                                    $t(
                                        'planPackageModules.form.labels.price_type',
                                    )
                                }}</strong>
                            </div>
                        </template>
                        <v-radio :label="'Único'" value="flat" />
                        <v-radio :label="'Por unidade'" value="unit" />
                    </v-radio-group>
                </v-col>
            </v-row>

            <v-row v-if="localPriceType && localPriceType !== 'flat'">
                <v-col cols="12" sm="6">
                    <v-text-field
                        v-model="localAmount"
                        :label="$t('planPackageModules.form.labels.amount')"
                        type="number"
                    />
                </v-col>
                <v-col cols="12" sm="6">
                    <v-text-field
                        v-model="localMaxAmount"
                        :label="$t('planPackageModules.form.labels.max_amount')"
                        hint="Máximo de unidades selecionáveis considerando a quantidade inicial. Caso deseje ilimitado, deixe -1."
                        persistent-hint
                        type="number"
                    />
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
import ModelSelect from '@/shared/inputs/ModelSelect'
import Module from '@/models/plans/Module'

export default {
    name: 'PlanPackageModuleFormBatch',
    components: { ModelSelect },
    props: {
        value: {
            type: Object,
            required: true,
        },
        index: {
            type: Number,
            required: true,
        },
    },
    data: () => ({
        local: {
            module_id: null,
            order: null,
            price: null,
            add_on: false,
            price_type: 'flat',
            amount: null,
            max_amount: null,
        },
        moduleModel: new Module(),
        selectedModule: null,
    }),
    computed: {
        localModuleId: {
            get() {
                return this.local.module_id
            },
            set(value) {
                this.$set(this.local, 'module_id', value)
                this.emitChange()
            },
        },
        localOrder: {
            get() {
                return this.local.order
            },
            set(value) {
                this.$set(this.local, 'order', value)
                this.emitChange()
            },
        },
        localPrice: {
            get() {
                return this.local.price
            },
            set(value) {
                this.$set(this.local, 'price', value)
                this.emitChange()
            },
        },
        localAddOn: {
            get() {
                return this.local.add_on
            },
            set(value) {
                this.$set(this.local, 'add_on', value)
                this.emitChange()
            },
        },
        localPriceType: {
            get() {
                return this.local.price_type
            },
            set(value) {
                this.$set(this.local, 'price_type', value)
                this.emitChange()
            },
        },
        localAmount: {
            get() {
                return this.local.amount
            },
            set(value) {
                this.$set(this.local, 'amount', value)
                this.emitChange()
            },
        },
        localMaxAmount: {
            get() {
                return this.local.max_amount
            },
            set(value) {
                this.$set(this.local, 'max_amount', value)
                this.emitChange()
            },
        },
    },
    watch: {
        value: {
            handler(newValue) {
                if (newValue && typeof newValue === 'object') {
                    this.local = {
                        module_id: newValue.module_id || null,
                        order: newValue.order || null,
                        price: newValue.price || null,
                        add_on:
                            newValue.add_on !== undefined
                                ? newValue.add_on
                                : false,
                        price_type: newValue.price_type || 'flat',
                        amount: newValue.amount || null,
                        max_amount: newValue.max_amount || null,
                    }
                }
            },
            immediate: true,
            deep: true,
        },
    },
    methods: {
        emitChange() {
            this.$emit('change-module', this.index, this.local)
        },
        selectModule() {
            this.localModuleId = this.selectedModule.external_id
            this.localPrice = this.selectedModule.partner_price
            this.localPriceType =
                this.selectedModule.price_type == 'per_unit'
                    ? 'unit'
                    : this.selectedModule.price_type || 'flat'
            this.localAmount = this.localPriceType == 'flat' ? 1 : 0
        },
        addOnChange() {
            if (this.localAddOn) {
                this.localAmount = 0
            } else {
                this.localAmount = 1
            }
        },
    },
}
</script>

<style></style>
